// extracted by mini-css-extract-plugin
export default {"login-container":"Login_login-container__kYpqU","title":"Login_title__tauOQ","login-form":"Login_login-form__Se5iw","input":"Login_input__qz5Cj","button":"Login_button__22Wej"};